import { render } from "./MediaLibraryGrid.vue?vue&type=template&id=780d481e"
import script from "./MediaLibraryGrid.vue?vue&type=script&lang=js"
export * from "./MediaLibraryGrid.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "780d481e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('780d481e', script)) {
    api.reload('780d481e', script)
  }
  
  module.hot.accept("./MediaLibraryGrid.vue?vue&type=template&id=780d481e", () => {
    api.rerender('780d481e', render)
  })

}

script.__file = "resources/js/Pages/Media/MediaLibraryGrid.vue"

export default script